import RestaurantName from "./RestaurantName";

export default RestaurantName;
